import { Component, Vue } from 'vue-property-decorator';
import WithRender from './metrics.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';

@WithRender
@Component({
  filters: {
  },
  components: {
    Loading
  }
})
export default class metrics extends Vue {
  isLoading = false;
  itemsMonthly = [];
  itemsPaymentMonthly=[];
  itemsDaily = [];
  itemsPaymentDaily = [];
  totalDaily =0;
  totalPaymentDaily=0;
  totalMonthly=0;
  totalPaymentMonthly=0;

  fields = [
    {
      key: "type",
      label: "Type",
      sortable: true,
    },
    {
      key: "count",
      label: "Count",
      sortable: true,
    },
    {
      key: "totalAmount",
      label: "Total Amount",
      sortable: true,
    }
  ]

  mounted() {
   
    this.getMonthly();
    this.getDaily();
    this.getPaymentDaily();
    this.getPaymentMonthly();
  }


  getMonthly(): void {
    //this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/walletReport/GetDepositsMetrics-Month`)
      .then(response => {
        this.itemsMonthly = response.data.items;
        this.totalMonthly = response.data.total;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        //this.isLoading = false;
      });
  }

   getPaymentMonthly(): void {
    //this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/walletReport/GetPaymentMetrics-Month`)
      .then(response => {
        this.itemsPaymentMonthly = response.data.items;
        this.totalPaymentMonthly = response.data.total;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        //this.isLoading = false;
      });
  }

    getDaily(): void {
    //this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/walletReport/GetDepositsMetrics-Day`)
      .then(response => {
        this.itemsDaily = response.data.items;
        this.totalDaily = response.data.total;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
      //  this.isLoading = false;
      });
  }

      getPaymentDaily(): void {
    //this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/walletReport/GetPaymentMetrics-Day`)
      .then(response => {
        this.itemsPaymentDaily = response.data.items;
        this.totalPaymentDaily = response.data.total;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
      //  this.isLoading = false;
      });
  }
}
